import styled from 'styled-components';
import { MButton } from '../../atoms/MButton';

export const StyledFloatingButton = styled(MButton)`
  z-index: 2147483648 !important;
  position: fixed;
  bottom: ${props => props.bottomPosition};
  right: ${props => props.rightPosition};

  box-shadow: 0px 11px 15px -7px rgb(0 0 0 / 20%),
    0px 24px 38px 3px rgb(0 0 0 / 14%), 0px 9px 46px 8px rgb(0 0 0 / 12%);
`;
